import { usePathname, useRouter } from 'next/navigation';
import { useCallback, useEffect, useMemo, useState } from 'react';

import {
  CUSTOMIZE_LAND_PLAT_MAP_URL,
  PLAT_MAP_URL,
  REPORTS_CENTER_URL,
  SAVED_SELECTIONS_URL,
} from '@/constants/urls';

import { TabTypes, tabUrls, useNavigationContext } from '../provider';
import NavLinkTab from './navLinkTab';

export const NavLinkTabs = () => {
  const [activeTab, setActiveTab] = useState('');
  const router = useRouter();
  const pathname = usePathname();
  const { getTabMap, aerialMapIsOpen } = useNavigationContext();

  const handleChange = useCallback(
    (val: TabTypes) => {
      setActiveTab(val);
      router.push(tabUrls[val]);
    },
    [router]
  );

  useEffect(() => {
    if (pathname?.includes(CUSTOMIZE_LAND_PLAT_MAP_URL)) {
      setActiveTab(TabTypes.CUSTOMIZE);
      return;
    }

    if (
      pathname?.includes(SAVED_SELECTIONS_URL) ||
      pathname?.includes(REPORTS_CENTER_URL)
    ) {
      setActiveTab(TabTypes.PORTFOLIO);
      return;
    }

    if (pathname?.includes(PLAT_MAP_URL)) {
      setActiveTab(TabTypes.MAP);
    }
  }, [pathname]);

  const tabs = useMemo(() => Object.values(getTabMap()), [getTabMap]);

  return (
    <div className="flex h-12 items-end antialiased">
      {tabs.map((tab) => (
        <NavLinkTab
          key={tab.value}
          disabled={aerialMapIsOpen}
          isActive={tab.value === activeTab}
          label={tab.label}
          onClick={() => handleChange(tab.value as TabTypes)}
        />
      ))}
    </div>
  );
};
